import smoothscroll from "smoothscroll-polyfill";

export class PageAncher {
  constructor() {
    this.triggers = {};
    this.body = {};
  }

  init() {
    this.body = document.getElementsByTagName("body")[0];
    this.links = document.querySelectorAll(".js-trigger");

    //window.scroll smooth not working on Safari
    smoothscroll.polyfill();

    this.links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        // 対象のY軸の絶対座標を取得
        let targetElemId = link.getAttribute("href").replace(/#/g, "");
        let targetElem = document.getElementById(targetElemId);

        if (targetElem) {
          let targetElemY = targetElem.getBoundingClientRect().top;
          let offsetY = window.pageYOffset;
          let scrollBuffer = 0;

          // 対象までのスクロール量を算出
          let targetTopY = targetElemY + offsetY - scrollBuffer;

          window.scroll({
            top: targetTopY, // スクロール量の設定
            behavior: "smooth", // スクロール動作の設定
          });
        }
      });
    });

    // for (let i = 0; i < this.links.length; i++) {
    //   this.links[i].addEventListener("click", (e) => {
    //     //console.log('clicked');
    //     e.preventDefault();

    //     // 対象のY軸の絶対座標を取得
    //     let targetElemId = this.links[i].getAttribute("href").replace(/#/g, "");
    //     let isTargetElem = false;

    //     let targetElemY;
    //     let offsetY;
    //     let scrollBuffer = 0;
    //     let targetTopY;

    //     if (document.getElementById(targetElemId)) {
    //       targetElemY = document
    //         .getElementById(targetElemId)
    //         .getBoundingClientRect().top;
    //       isTargetElem = true;

    //       // 現在のスクロール量を取得
    //       offsetY = window.pageYOffset;

    //       // スクロール位置に持たせるバッファ
    //       // let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
    //       // scrollBuffer = 76;
    //       // if (windowWidth < 1000) {
    //       //     scrollBuffer = 0;
    //       // }

    //       // 対象までのスクロール量を算出
    //       targetTopY = targetElemY + offsetY - scrollBuffer;

    //       window.scroll({
    //         top: targetTopY, // スクロール量の設定
    //         behavior: "smooth", // スクロール動作の設定
    //       });
    //     }
    //   });
    // }
  }
}
